export default __webpack_public_path__ + "static/media/coins.3956b993.svg";